import Vue from 'vue'
import moment from 'moment'
import { ContentMode, UseStatus, voucherIsOpen, voucherOnGoing } from '../utils/index'
const ConsultStatus = [
  { label: '待受理', value: 0 },
  { label: '受理中', value: 1 },
  { label: '处理完成', value: 2 },
  { label: '已拒绝', value: 9 }
]
const Filters = {}
Filters.install = function(Vue) {
  Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    if (dataStr) {
      return moment(dataStr).format(pattern)
    }
    return ''
  })
  Vue.filter('ConsultStatusName', function(val) {
    const item = ConsultStatus.find(i => i.value === val) || {}
    return item.label || '-'
  })
  Vue.filter('ContentModeName', function(val) {
    const item = ContentMode.find(i => i.value === val) || {}
    return item.label || '-'
  })

  Vue.filter('VoucherIsOpenName', function(val) {
    const item = voucherIsOpen.find(i => i.value === val) || {}
    return item.label || '-'
  })

  Vue.filter('VoucherOnGoingName', function(val) {
    const item = voucherOnGoing.find(i => i.value === val) || {}
    return item.label || '-'
  })

  Vue.filter('UseStatusName', function(val) {
    const item = UseStatus.find(i => i.value === val) || {}
    return item.label || '-'
  })

  Vue.filter('imageFixed', function(src, width = 750) {
    if (src) {
      const url = src.split('.')
      const index = url.length - 2
      url[index] = `${url[index]}_${width}x0`
      return url.join('.')
    } else {
      return src
    }
  })
  Vue.filter('getFilename', function(file) {
    if (file.indexOf('originalfilename') > -1) {
      return file.split('originalfilename')[1].slice(1)
    }
    return file
  })
  Vue.filter('currency', function(num) {
    const reg = /\d{1,3}(?=(\d{3})+$)/g
    return (num + '').replace(reg, '$&,')
  })
  Vue.filter('tagCount', function(count) {
    return ('0000000000' + count).slice(-10)
  })
  Vue.filter('tagModel', function(type) {
    const typeMap = { 1: '产品码', 2: '套码' }
    if (Array.isArray(type)) {
      return type.map(o => typeMap[o]).join(',')
    }
    return typeMap[type]
  })
  Vue.filter('tradeType', function(type) {
    const typeMap = { 1: '进出口贸易', 3: '国内贸易' }
    if (Array.isArray(type)) {
      return type.map(o => typeMap[o]).join(',')
    }
    return typeMap[type]
  })
  Vue.filter('needStatus', function(num) {
    const map = { 0: '待受理', 2: '已受理', 3: '已完成', 9: '不受理' }
    return map[num] || ''
  })

  Vue.filter('trainingTypeName', function(num) {
    const map = { 1: '线上', 2: '线下' }
    return map[num] || ''
  })

  Vue.filter('linkTypeName', function(type, appendVal) {
    console.log(appendVal)
    const LoginType = {
      0: '平台内容',
      1: '商品',
      3: '抽奖活动',
      4: '积分活动',
      5: '限时优惠',
      6: '专区',
      11: '商品组',
      13: '专区',
      10: '追溯页面',
      15: '单图',
      '06': '视频',
      51: '鉴定中心入口',
      50: '鉴定考试入口',
      '0101': '营业网点',
      200: '资讯详情',
      201: '资讯中心',

      220: '产品白名单',
      221: '产品中心',

      230: '人员白名单',
      231: '人员中心',

      240: '合作企业',
      241: '企业中心',

      250: '合作机构',
      251: '机构中心',

      260: '合作服务',
      261: '服务中心',

      271: '金盾调解'
    }
    return LoginType[appendVal ? type + '' + appendVal : type]
  })
}

Vue.use(Filters)
